import script from "./AppAccordion.vue?vue&type=script&setup=true&lang=js"
export * from "./AppAccordion.vue?vue&type=script&setup=true&lang=js"

import "./AppAccordion.vue?vue&type=style&index=0&id=5ffd98d8&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ffd98d8"]])

export default __exports__